import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutBusinessContextUploadRequest = {
	context: string;
	file: File;
};

export const putBusinessContextUpload = createPutEndpoint<PutBusinessContextUploadRequest>(
	'/api/v3/core/business-contexts/upload',
	{
		requestTransform: (request) => ({
			fileOptions: {
				file: request.file,
				formName: 'file'
			},
			formFields: {
				context: request.context
			}
		})
	}
);
